import { Link, useLocation} from "react-router-dom";
import { ArrowBackIcon } from "./Icons";
import React, { useState, useEffect, useRef } from 'react';
import Typed from 'typed.js';
import "./../AppMathMode.css";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {getLeadership, getMentorship, getTeaching} from './updatables';
import { useMediaQuery } from 'react-responsive';

const TeachingAndServiceMathMode = ({page}) => {
  const isSmallScreen = useMediaQuery({ maxWidth: 670 });

    const [leadership, setLeadership] = React.useState([]);
    const [mentorship, setMentorship] = React.useState([]);
    const [teaching, setTeaching] = React.useState([]);

    React.useEffect(() => {
        async function loadLeadership() {
            const data = await getLeadership();
            setLeadership(data);
        }

        loadLeadership();
    }, []);

    React.useEffect(() => {
        async function loadMentorship() {
            const data = await getMentorship();
            setMentorship(data);
        }

        loadMentorship();
    }, []);

    React.useEffect(() => {
        async function loadTeaching() {
            const data = await getTeaching();
            setTeaching(data);
        }

        loadTeaching();
    }, []);

    return <div class="body" style={{height: "auto", width: "100%", position: "relative", backgroundSize: "cover", color: "black", backgroundPosition: "center", zIndex: 0, display: "inline-block", justifyContent: "space-between", padding: "16px", margin: "0px"}}>
        Teaching:
        <ul style={{paddingTop: "16px"}}>
        {teaching.map((item, index) => (
            <li
            key={index}
            style={{
                fontFamily: "Garamond, serif",
                fontSize: "22px",
                paddingBottom: "8px",
            }}
            >
            <span style={{textDecoration: "underline", fontFamily: "Garamond, serif"}}>{item.course}</span> ({item.role}), {item.semesters}, {item.institution}
            </li>
        ))}
        </ul>
        Leadership:
        <ul>
        {leadership.map((item, index) => (
            <li
            key={index}
            style={{
                fontFamily: "Garamond, serif",
                fontSize: "22px",
                paddingBottom: "8px"
            }}
            >
            <span style={{textDecoration: "underline", fontFamily: "Garamond, serif"}}>{item.role}</span>, {item.location}, {item.terms}
            </li>
        ))}
        </ul>
        Mentorship:
        <ul>
        {mentorship.map((item, index) => (
            <li
            key={index}
            style={{
                fontFamily: "Garamond, serif",
                fontSize: "22px",
                paddingBottom: "8px"
            }}
            >
            <span style={{textDecoration: "underline", fontFamily: "Garamond, serif"}}>{item.role}</span>, {item.location}, {item.terms}
            </li>
        ))}
        </ul>
    </div>;
};

export default TeachingAndServiceMathMode;